import { useCallback } from 'react';
import UsageTracker from '../../../utils/UsageTracker';
export const useTableSorting = ({
  sortBy,
  sortOrder,
  setSortBy,
  setSortOrder
}) => {
  const handleSortChange = useCallback(columnName => {
    if (sortBy === columnName) {
      setSortOrder(sortOrder === 'ASC' ? 'DESC' : 'ASC');
    } else {
      setSortBy(columnName);
      setSortOrder('ASC');
      UsageTracker.track('teamInteraction', {
        action: 'change-sort-by',
        value: columnName
      });
    }
  }, [sortBy, sortOrder, setSortBy, setSortOrder]);
  const getSortDirectionForColumn = useCallback(columnName => {
    if (sortBy !== columnName) return 'none';
    return sortOrder === 'ASC' ? 'ascending' : 'descending';
  }, [sortBy, sortOrder]);
  return {
    handleSortChange,
    getSortDirectionForColumn
  };
};